import { useMemo } from 'react';
import { getUrl } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';
import { LocalizationLinkedList, MinimumServingForm, Loader } from 'components';
import { advancedLocalizationPages } from 'constants';
import { routes } from 'config';
import * as S from './AdvancedMinimumServingPage.styled';
import { useSelector } from 'react-redux';

const pba_id = 'c490cd1d-72a5-40ad-9899-b42b3fe4cc33';

const AdvancedMinimumServingPage = () => {
  const pages = useMemo(
    () =>
      advancedLocalizationPages.map((page) => {
        return { ...page, link: getUrl(routes, page.url_id) };
      }),
    [],
  );
  const isAdvertiser = useSelector((state) => state.auth.pb_roles).includes('advertiser');
  const { data, isLoading, isSuccess } = manageAppsAPI.useFetchAppAdvancedDataQuery({
    pba_id,
    isAdvertiser,
  });
  return (
    <>
      <S.Container>
        {isLoading && <Loader.Global />}
        <h1>Advanced Settings (Local Data)</h1>
        <S.Main>
          <S.Wrap>
            <S.ListPosition>
              <LocalizationLinkedList data={pages} show={true} />
            </S.ListPosition>
            {!data && isSuccess && <div>Server Error</div>}
            {!isSuccess && <Loader.Global />}
            {data && <MinimumServingForm data={data} />}
          </S.Wrap>
        </S.Main>
      </S.Container>
    </>
  );
};

export default AdvancedMinimumServingPage;
